import React from "react";
import T from "prop-types";
import { dollars } from "LIB/formatters/currency";
import { Map, List } from "immutable";
import {
  Authorized,
  FilterTag,
  SearchPropTypes
} from "MODULES/shared/components";
import _ from "lodash";

export function createFilters(filters, paginator) {
  return filters.reduce((active, f) => {
    const value = paginator.getIn(["filters", f.key]);

    const filterActive = f.matchesTarget
      ? f.matchesTarget(value)
      : value !== undefined;

    if (filterActive) {
      return active.push(
        Map({
          key: f.key,
          label: f.label,
          value,
          withAuthorization: f.withAuthorization
        })
      );
    }

    return active;
  }, List());
}

export default function TitleWithFilters({
  children,
  filters = [],
  title,
  paginator,
  results,
  pageActions,
  aggregateField
}) {
  const aggregateReducer = (total, currentValue) =>
    total +
    parseFloat(
      typeof aggregateField === "function"
        ? aggregateField(currentValue)
        : _.get(currentValue, aggregateField)
    );

  const activeFilters = createFilters(filters, paginator);

  return (
    <div>
      <h2>
        {title}
        <span className="small">
          &nbsp;Showing {paginator.get("totalCount")} Item(s)&nbsp;&nbsp;
        </span>
        {activeFilters.map((f, index) => {
          const filterTag = (
            <React.Fragment key={index}>
              <FilterTag
                label={f.get("label")}
                clear={() => {
                  if (
                    f.get("key").includes("application") &&
                    activeFilters.every(a =>
                      [f.get("key"), "active", "sellable_qty"].includes(
                        a.get("key")
                      )
                    )
                  ) {
                    pageActions.setFilter("sellable_qty", undefined);
                    pageActions.setFilter("active", undefined);
                  }
                  pageActions.setFilter(f.get("key"), undefined);
                }}
              />
              &nbsp;
            </React.Fragment>
          );

          const withAuthorization = f.get("withAuthorization");

          if (withAuthorization) {
            return <Authorized {...withAuthorization}>{filterTag}</Authorized>;
          }

          return filterTag;
        })}
        {aggregateField && (
          <span className="float-right">
            &nbsp;Page Total:{" "}
            {dollars(results.reduce(aggregateReducer, 0).toFixed(2))}{" "}
            &nbsp;&nbsp;
            {_.get(paginator.toJS(), "data.sum") !== undefined && (
              <span>/&nbsp;&nbsp;{_.get(paginator.toJS(), "data.sum")}</span>
            )}
          </span>
        )}
        {children}
      </h2>
    </div>
  );
}

TitleWithFilters.propTypes = {
  aggregateField: T.string,
  title: T.string.isRequired,
  filters: T.arrayOf(
    T.shape({
      label: T.string.isRequired,
      key: T.string.isRequired,
      matchesTarget: T.func
    })
  ),
  setFilter: T.func,
  ...SearchPropTypes
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Search/TitleWithFilters.jsx